import React from "react";

function BookingsCard({
  astrologerName,
  astrologerImage,
  astrologerExpertise,
  bookingDate,
}) {
  return (
    // Main card container
    <div className="flex items-center gap-[15px] p-[15px] border border-gray-200 rounded-[12px] bg-white w-full max-w-lg mx-auto">
      {/* Astrologer Profile Image */}
      <div className="w-[64px] h-[64px] rounded-full overflow-hidden flex-shrink-0">
        <img
          src={astrologerImage} // e.g., "/images/acharya-vivek-small.png"
          alt={`${astrologerName}'s profile`}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Astrologer Details */}
      <div className="flex-grow flex flex-col gap-[5px]">
        <h3 className="web-h5 text-gray-900 leading-tight">{astrologerName}</h3>
        <p className="web-body-md text-secondary-950 leading-tight">
          {astrologerExpertise}
        </p>
      </div>

      {/* Booking Date */}
      <div className="flex-shrink-0 web-body-md text-gray-500">
        {bookingDate}
      </div>
    </div>
  );
}

export default BookingsCard;
